import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./search-assigned-to.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./search-assigned-to.component.scss?ngResource";
/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ChangeDetectorRef, Component } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { ApplicationSearchConstants } from "../application-search-constants";
import { ApplicationSearchService } from "../../shared/application-search.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { Subject, take } from "rxjs";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { AlertType } from "../../../../shared/models/alert";
import { AppControllerService } from "../../../../app-controller.service";
import { Store } from "@ngrx/store";
import { takeUntil } from "rxjs/operators";
import { AutoUnsub } from "../../../../shared/decorators/autounsub.decorator";
let SearchAssignedToComponent = class SearchAssignedToComponent {
    applicationSearchService;
    aflaModuleStrategyService;
    appController;
    changeDetectorRef;
    store;
    _destroy$ = new Subject();
    assignedToLabel = ApplicationSearchConstants.FORM_CONTROLS.assignedToLabel;
    assignedToUsersFormControl = ApplicationSearchConstants.FORM_CONTROLS.assignedToUsersFormControl;
    placeholder = SharedConstants.SEARCH_BY_DEFAULT;
    searchText = ApplicationSearchConstants.FORM_CONTROLS.searchText;
    assignedToUsersForm;
    moduleUsers;
    tabChanged;
    applicationSearchCallback;
    getUsersForModuleSubscription;
    constructor(applicationSearchService, aflaModuleStrategyService, appController, changeDetectorRef, store) {
        this.applicationSearchService = applicationSearchService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.changeDetectorRef = changeDetectorRef;
        this.store = store;
    }
    ngOnInit() {
        this.setUpForm();
        this.getUsersForModuleSubscription = this.aflaModuleStrategyService.getUsersForModule(Number(this.appController.selectedModuleID))
            .subscribe((users) => {
            this.moduleUsers = users.value;
            this.changeDetectorRef.detectChanges();
        });
    }
    setUpForm() {
        this.assignedToUsersForm = new FormGroup({
            assignedToUsersFormControl: new FormControl("")
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    searchApplication($event) {
        const apps = this.store.select("applicationFormGroup");
        const tabSwitched = this.store.select("applicationTabChanged");
        tabSwitched.pipe(takeUntil(this._destroy$), take(1)).subscribe({
            next: (tab) => {
                this.tabChanged = tab;
            }
        });
        apps.pipe(takeUntil(this._destroy$), take(1)).subscribe(val => {
            if (val != null && this.tabChanged) {
                this.assignedToUsersForm = val;
            }
        });
        const userId = this.assignedToUsersForm.get(this.assignedToUsersFormControl).value;
        if (userId !== "") {
            this.applicationSearchCallback(this.applicationSearchService.searchByUser(Number(userId), Number(this.appController.selectedModuleID), this.aflaModuleStrategyService));
        }
        else {
            this.appController.showMessage(`${SharedConstants.NO_OPTION_SELECTED}`, AlertType.Warning);
        }
    }
    static ctorParameters = () => [
        { type: ApplicationSearchService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: Store }
    ];
};
SearchAssignedToComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-search-assigned-to",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], SearchAssignedToComponent);
export { SearchAssignedToComponent };
